import { Link } from "react-router-dom";
import Logo from "./Logo";
import IconBar from "./IconBar";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { useState } from "react";
import {
  Sheet, SheetContent, SheetTrigger,
} from "@/components/ui/sheet";

const links = [
  { to: "/", label: "Início", testid: "nav-home-link" },
  { to: "/torneios", label: "Torneios", testid: "nav-calendar-link" },
  { to: "/hall-da-fama", label: "Hall da Fama", testid: "nav-hall-of-fame-link" },
  { to: "/aula-experimental", label: "Aula Experimental", testid: "nav-experimental-link" },
];

export default function PublicNavbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#061426]/95 shadow-[0_10px_30px_rgba(2,11,29,0.16)] backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2"><Logo size={48} /></Link>
        <div className="hidden md:block"><IconBar items={links} /></div>
        <div className="hidden md:flex items-center gap-3">
          <Link to="/login">
            <Button data-testid="nav-athlete-login-btn"
              className="bg-amber-500 text-[#071A33] hover:bg-amber-400 font-semibold">
              Área do Atleta
            </Button>
          </Link>
        </div>
        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" data-testid="nav-menu-mobile"><Menu className="text-slate-100" /></Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#071A33] border-l border-amber-500/20">
              <div className="flex flex-col gap-4 mt-8">
                {links.map((l) => (
                  <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                    className="text-slate-100 hover:text-amber-400 py-2 text-base border-b border-amber-500/10">
                    {l.label}
                  </Link>
                ))}
                <Link to="/login" onClick={() => setOpen(false)}>
                  <Button className="w-full bg-amber-500 text-[#071A33] hover:bg-amber-400 font-semibold">
                    Área do Atleta
                  </Button>
                </Link>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
